import React, { useState, useEffect, useCallback } from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Orbit from './components/Orbit';
import FStage from './components/FStage';
import Stack from './components/Stack';
import Flow from './components/Flow';
import FAQ from './components/FAQ';
import Final from './components/Final';
import Footer from './components/Footer';
import Toast from './components/Toast';
import './styles/global.css';

function App() {
  const [toast, setToast] = useState({ show: false, message: '' });

  const showToast = useCallback((message) => {
    setToast({ show: true, message });
  }, []);

  const hideToast = useCallback(() => {
    setToast({ show: false, message: '' });
  }, []);

  // Reveal animation on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );

    document.querySelectorAll('.reveal').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div id="siteShell">
      <a className="skip-link" href="#mainContent">跳到主要内容</a>
      
      <Nav />
      
      <main id="mainContent" tabIndex={-1}>
        <Hero />
        <Orbit />
        <FStage />
        {/* Stack 和 Flow 区域已按要求隐藏 */}
        {/* <Stack /> */}
        {/* <Flow /> */}
        {/* Perm, Proof, Market 区域已按要求隐藏 */}
        <FAQ />
        <Final />
      </main>
      
      <Footer />
      
      {/* Toast notification */}
      <Toast 
        message={toast.message} 
        show={toast.show} 
        onClose={hideToast} 
      />
    </div>
  );
}

export default App;
